export default {
  locations: [
    {
      domain: 'com',
      iso: 'en',
      name: 'English',
      visible: false
    },
    // Used for local development area
    {
      domain: 'test',
      iso: 'en',
      name: 'English',
      visible: false
    }
  ]
}
